import React, { useEffect, useState } from "react";
import { apiFetch } from "../../api/apiFetch";
import ErrorModal from "../../components/ErrorModal";
import { MONTH_NAMES, apiErrorMessage, formatHoursMinutes } from "../../utils/timesheets";

/** Overzicht per code en per maand (controle bij het doorgeven aan het sociaal secretariaat). */
export default function CodeOverview({ staff }) {
  const internals = staff.filter((s) => s.has_internal);
  const [memberId, setMemberId] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!memberId && internals.length) setMemberId(internals[0].id);
  }, [internals, memberId]);

  useEffect(() => {
    if (!memberId) return;
    apiFetch(`/timesheets/internal/code-overview?year=${year}&member_id=${memberId}`)
      .then(setData)
      .catch((err) => setError(apiErrorMessage(err)));
  }, [memberId, year]);

  if (internals.length === 0) return <p className="text-sm text-gray-500">Nog geen interne medewerkers.</p>;

  const codes = (data?.codes || []).filter((c) =>
    Object.values(data.months).some((m) => m[c.code])
  );
  const total = (code) =>
    Object.values(data.months).reduce(
      (acc, m) => ({ days: acc.days + (m[code]?.days || 0), minutes: acc.minutes + (m[code]?.minutes || 0) }),
      { days: 0, minutes: 0 }
    );

  return (
    <div>
      {error && <ErrorModal message={error} onClose={() => setError("")} />}
      <div className="flex flex-wrap items-end gap-4 mb-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1" htmlFor="co-member">Personeelslid</label>
          <select id="co-member" value={memberId} onChange={(e) => setMemberId(e.target.value)} className="border border-gray-300 rounded px-2 py-1.5 text-sm w-64">
            {internals.map((s) => <option key={s.id} value={s.id}>{s.naam}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1" htmlFor="co-year">Jaar</label>
          <input id="co-year" type="number" value={year} onChange={(e) => setYear(Number(e.target.value))} className="border border-gray-300 rounded px-2 py-1.5 text-sm w-24" />
        </div>
      </div>
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-x-auto">
        <table className="w-full text-sm" style={{ minWidth: 900 }}>
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase">
              <th className="px-3 py-2 text-left">Code</th>
              {MONTH_NAMES.map((m) => <th key={m} className="px-3 py-2 text-right">{m.slice(0, 3)}</th>)}
              <th className="px-3 py-2 text-right">Totaal</th>
            </tr>
          </thead>
          <tbody>
            {!data && <tr><td colSpan={14} className="px-3 py-8 text-center text-gray-400">Laden...</td></tr>}
            {data && codes.length === 0 && <tr><td colSpan={14} className="px-3 py-8 text-center text-gray-400">Geen registraties in {year}.</td></tr>}
            {codes.map((c) => {
              const t = total(c.code);
              return (
                <tr key={c.code} className="border-b border-gray-50">
                  <td className="px-3 py-1.5"><span className="font-medium">{c.code}</span> <span className="text-gray-500">{c.description}</span></td>
                  {Array.from({ length: 12 }, (_, i) => {
                    const cell = data.months[i + 1][c.code];
                    return (
                      <td key={i} className="px-3 py-1.5 text-right tabular-nums" title={cell ? `${cell.days} dag(en)` : ""}>
                        {cell ? formatHoursMinutes(cell.minutes) : ""}
                      </td>
                    );
                  })}
                  <td className="px-3 py-1.5 text-right tabular-nums font-semibold" title={`${t.days} dag(en)`}>{formatHoursMinutes(t.minutes)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
